<template>
    <div class="specialDetaidBox">
        <img src="../../assets/special/fuli.jpg" alt="" class="welfare" v-if="isMobile">
        <div v-else>
            <img src="../../assets/special/fuli_pc1.jpg" alt="" class="welfare">
            <div class="special_box">
                <backSpecial></backSpecial>
                <img src="../../assets/special/fuli_pc2.jpg" alt="" class="welfare">
            </div>
        </div>
    </div>
</template>

<script>
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {

        }
    },
    components: {
        backSpecial
    }
}
</script>

<style lang="less" scoped>
@import url(../../styles/specialDetail.less);
.specialDetaidBox{
    min-height: 100vh;
    background-color: #f8f8f8;
}
.welfare {
    width: 100%;
    display: block;
}

.special_box {
    padding: 20px 20px;
    max-width: 1200px;
    margin: auto;
}
</style>